<template>
    <el-dialog
        v-drag
        class="manage-driver--sign-detail"
        :visible="visible"
        title="签署详情"
        width="1200px"
        :close-on-click-modal="true"
        :before-close="handleClose">
        <el-table border :data="tableData" v-loading="loading">
            <el-table-column prop="contractNo" label="合同编号" :show-overflow-tooltip="true" width="150px"></el-table-column>
            <el-table-column prop="contractName" label="合同名称" :show-overflow-tooltip="true" width="160px"></el-table-column>
            <el-table-column prop="contractUser" label="签署人" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="contractUserMobile" label="签署手机" :show-overflow-tooltip="true" width="120px"></el-table-column>
            <el-table-column prop="contractStatusName" label="签署状态" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="remark" label="签署失败原因" :show-overflow-tooltip="true" width="265px"></el-table-column>
            <el-table-column prop="signTime" label="签署时间" :show-overflow-tooltip="true" width="160px"></el-table-column>
            <el-table-column prop="type_" label="类型" :show-overflow-tooltip="true" width="100px"></el-table-column>
            <el-table-column label="操作" width="50px">
                <template slot-scope="scope">
                    <el-button v-if="scope.row._repushVisible" type="text" @click="handleRepush(scope.row)">重推</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="sign-tips">注：签署状态为“已撤回”的，如需要继续签署委派函，请编辑司机，调整委派开始或结束时间， 提交后即会重新发起签署流程。</div>
    </el-dialog>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api';
import { getSign, repushSign } from '../../../../../../api/register/driver.js';

const FAILURE = '-1'; // 签署失败 SRM_SUPPLIER_DELEGATE_STATUS
const ZTB_SIGN = '2'; // 直通宝签署 SRM_SUPPLIER_DIRVER_SIGN_TYPE

export default {
    name: 'SignDetailDialog',
    props: { },
    data() {
        return {
            loading: false,
            tableData: [],
            visible: false,
            dict: {},
            contractNo: null
        };
    },
    mounted() {
        dictWithUrl('SRM_SUPPLIER_DELEGATE_STATUS,SRM_SUPPLIER_DIRVER_SIGN_TYPE').then(res => {
            if (res && +res.code === 0) {
                this.dict = res.data;
            }
        });
    },
    methods: {
        handleOpen(contractNo) {
            this.visible = true;
            this.contractNo = contractNo;
            this.loading = true;
            getSign({ contractNo }).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = res.data.map(item => {
                        item.contractStatusName = this.dict.SRM_SUPPLIER_DELEGATE_STATUS[item.contractStatus];
                        item.type_ = this.dict.SRM_SUPPLIER_DIRVER_SIGN_TYPE[item.type];
                        item._repushVisible = +item.contractStatus === +FAILURE && +item.type === +ZTB_SIGN;
                        return item;
                    });
                }
            }).finally(() => { this.loading = false; });
        },
        handleClose() {
            this.visible = false;
            this.tableData = [];
        },
        handleRepush(row) {
            this.loading = true;
            repushSign({ contractNo: row.contractNo }).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('已重推!');
                    this.handleOpen(this.contractNo);
                }
            }).finally(() => { this.loading = false; });
        }
    }
};
</script>
<style lang="less" scoped>
.sign-tips {
    margin-top: 5px;
    font-size: 13px;
    color: #252626;
}
</style>